module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/5-549d2d590a9dacfa5e1669607c0634ec.jpg";